/**
 * @description Renders the page level actions in the page header
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import * as ReactDOM from 'react-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';

import { ActionsContext } from '../contexts/actions';

/**
 * @prop {() => void} onDelete - a callback function that is run when the user clicks the delete all action button
 */
const HeaderActions = ({ onDelete }) => {
  const actionsEl = React.useContext(ActionsContext);

  // If the reference to the actions react element is not defined yet, do nothing
  if (actionsEl === null) {
    return null;
  }

  return ReactDOM.createPortal(
    (
      <Button
        onClick={() => onDelete()}
        startIcon={<DeleteIcon />}
        variant='outlined'
      >
        Delete All
      </Button>
    ), actionsEl
  );
};

HeaderActions.propTypes = {
  onDelete: PropTypes.func.isRequired
};

export default HeaderActions;
